import { jsx as e, jsxs as m, Fragment as j } from "react/jsx-runtime";
import { Popover as B, PopoverButton as I, Transition as z, PopoverPanel as A, FocusTrap as D, FocusTrapFeatures as H } from "@headlessui/react";
import { useState as M, useRef as R, useEffect as S, Fragment as U } from "react";
import { HexAlphaColorPicker as W, HexColorPicker as $, HexColorInput as q } from "react-colorful";
import { TooltipCustomButton as G } from "../tooltip/custom-button.mjs";
import { twMerge as o } from "tailwind-merge";
import { FieldErrorAndDescription as J } from "../form/field-error-and-description.mjs";
const ee = ({
  color: i,
  labelClassName: h,
  popoverClassName: b,
  popoverButtonClassName: y,
  popoverButtonChildClassName: k,
  hexColorInput: E,
  wrapperClassName: w,
  children: u,
  additionalPopoverChildren: l,
  focusTrapFeatures: F = H.None,
  stayWhenUnfocused: N = !1,
  showAlpha: f = !0,
  showOnlyHue: s = !1,
  pickerRef: p,
  error: v,
  description: L,
  anchor: T = "top",
  disabled: C,
  ...g
}) => {
  const [P, c] = M(!1), d = R(null);
  S(() => {
    const r = (a) => {
      var x;
      (x = d.current) != null && x.contains(a.target) && c(!0);
    }, t = (a) => {
      d.current && !d.current.contains(a.target) && c(!1);
    }, n = (a) => {
      a.key === "Escape" && c(!1);
    };
    return document.addEventListener("focusin", r), document.addEventListener("touchstart", t, !0), document.addEventListener("mousedown", t, !0), document.addEventListener("keydown", n), () => {
      document.removeEventListener("focusin", r), document.removeEventListener("touchstart", t, !0), document.removeEventListener("mousedown", t, !0), document.removeEventListener("keydown", n);
    };
  }, []), p && (p.current = {
    allowToHideWhenUnfocused: (r) => {
      c(!r);
    }
  });
  const _ = f && !s ? W : $;
  return /* @__PURE__ */ e(B, { className: "flex items-center", children: ({ open: r, close: t }) => {
    const n = N && P || r;
    return /* @__PURE__ */ m(j, { children: [
      /* @__PURE__ */ e(
        I,
        {
          disabled: C,
          as: G,
          className: o(
            "relative truncate outline-hidden",
            "cursor-pointer",
            "h-full w-full max-w-fit",
            "focus-ring rounded-lg",
            v && "border-danger rounded-xl border-2 p-0.5",
            y
          ),
          children: (u == null ? void 0 : u(n)) ?? /* @__PURE__ */ e(
            "div",
            {
              style: { backgroundColor: i },
              className: o(
                "border-text-secondary/30 h-10 w-10 rounded-lg border",
                k
              )
            }
          )
        }
      ),
      /* @__PURE__ */ e(
        z,
        {
          as: U,
          show: n,
          enter: "transition duration-100 ease-out",
          enterFrom: "opacity-0",
          enterTo: "opacity-100",
          leave: "transition duration-75 ease-in",
          leaveFrom: "opacity-100",
          leaveTo: "opacity-0",
          children: /* @__PURE__ */ e(
            A,
            {
              ref: d,
              anchor: T,
              className: o(
                "background-secondaryspace-normal relative w-fit px-5 py-3",
                "bg-background-secondary shadow-3xl rounded-lg",
                "[--anchor-gap:8px]",
                "z-30",
                s ? "pt-4" : "pt-5",
                b
              ),
              children: /* @__PURE__ */ e(D, { features: F, children: /* @__PURE__ */ e(
                "div",
                {
                  className: o(
                    "text-text-tertiary font-averta w-full break-normal text-center text-sm font-medium",
                    "max-w-[200px]",
                    h
                  ),
                  children: /* @__PURE__ */ m(
                    "div",
                    {
                      className: o(
                        "flex flex-col gap-3",
                        s && "[&_.react-colorful]:!h-fit [&_div.react-colorful>div:first-child]:hidden [&_div.react-colorful>div:nth-of-type(2)]:!rounded-lg",
                        w
                      ),
                      children: [
                        /* @__PURE__ */ e(_, { color: i, ...g }),
                        !s && /* @__PURE__ */ m("div", { className: "flex", children: [
                          /* @__PURE__ */ e("div", { className: "bg-background-tertiary rounded-l-lg p-2", children: "#" }),
                          /* @__PURE__ */ e(
                            q,
                            {
                              alpha: f,
                              className: o(
                                "main-transition-colors border-text-secondary/30 focus:border-brand-primary w-full rounded-r-lg border p-2 outline-hidden",
                                E
                              ),
                              color: i,
                              onChange: g.onChange
                            }
                          )
                        ] }),
                        l == null ? void 0 : l(t),
                        /* @__PURE__ */ e(
                          J,
                          {
                            errorClassName: "text-left",
                            error: v,
                            description: L
                          }
                        )
                      ]
                    }
                  )
                }
              ) })
            }
          )
        }
      )
    ] });
  } });
};
export {
  ee as ColorPicker
};
